import {
  Component,
  DestroyRef,
  Input,
  OnDestroy,
  inject,
} from "@angular/core";
import { DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import { ButtonConfiguration, SharedUiButtonModule } from '@snelstart/ui-button';
import {filter, Observable, shareReplay, Subscriber, tap} from 'rxjs';
import {
  BokkzVpbDataService,
  BokkzVpbLogic,
  CorporateTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {ToastService} from "@snelstart/ui-toast";
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import {
  TekstBelastingplichtigeComponent
} from '../corporate/toelichtingen-tekst/tekst-belastingplichtige/tekst-belastingplichtige.component';
import {
  TekstAdministratieKoppelenComponent
} from '../corporate/toelichtingen-tekst/tekst-administratie-koppelen/tekst-administratie-koppelen.component';
import {
  TekstVragenVoorafComponent
} from '../corporate/toelichtingen-tekst/tekst-vragen-vooraf/tekst-vragen-vooraf.component';
import {
  TekstSamenstellingFiscaleEenheidComponent
} from '../corporate/toelichtingen-tekst/tekst-samenstelling-fiscale-eenheid/tekst-samenstelling-fiscale-eenheid.component';
import {
  TekstVragenFiscaleEenheidComponent
} from '../corporate/toelichtingen-tekst/tekst-vragen-fiscale-eenheid/tekst-vragen-fiscale-eenheid.component';
import {
  TekstBalansActivaComponent
} from '../corporate/toelichtingen-tekst/tekst-balans-activa/tekst-balans-activa.component';
import {
  TekstBalansPassivaComponent
} from '../corporate/toelichtingen-tekst/tekst-balans-passiva/tekst-balans-passiva.component';
import {
  TekstResultatenrekeningComponent
} from '../corporate/toelichtingen-tekst/tekst-resultatenrekening/tekst-resultatenrekening.component';
import {
  TekstVermogensvergelijkingComponent
} from '../corporate/toelichtingen-tekst/tekst-vermogensvergelijking/tekst-vermogensvergelijking.component';
import {
  TekstVrijgesteldeWinstComponent
} from '../corporate/toelichtingen-tekst/tekst-vrijgestelde-winst/tekst-vrijgestelde-winst.component';
import {
  TekstBeperktAftrekbareKostenComponent
} from '../corporate/toelichtingen-tekst/tekst-beperkt-aftrekbare-kosten/tekst-beperkt-aftrekbare-kosten.component';
import {
  TekstNietAftrekbareRenteComponent
} from '../corporate/toelichtingen-tekst/tekst-niet-aftrekbare-rente/tekst-niet-aftrekbare-rente.component';
import {
  TekstInvesteringsaftrekComponent
} from '../corporate/toelichtingen-tekst/tekst-investeringsaftrek/tekst-investeringsaftrek.component';
import {
  TekstInvesteringenOverigComponent
} from '../corporate/toelichtingen-tekst/tekst-investeringen-overig/tekst-investeringen-overig.component';
import {
  TekstAftrekbareCultureleGiftenComponent
} from '../corporate/toelichtingen-tekst/tekst-aftrekbare-culturele-giften/tekst-aftrekbare-culturele-giften.component';
import {
  TekstAftrekbareGewoneGiftenComponent
} from '../corporate/toelichtingen-tekst/tekst-aftrekbare-gewone-giften/tekst-aftrekbare-gewone-giften.component';
import {
  TekstVerliesverrekeningComponent
} from '../corporate/toelichtingen-tekst/tekst-verliesverrekening/tekst-verliesverrekening.component';
import {
  TekstBelastbaarbedragComponent
} from '../corporate/toelichtingen-tekst/tekst-belastbaarbedrag/tekst-belastbaarbedrag.component';
import {
  TekstBelastingbedragComponent
} from '../corporate/toelichtingen-tekst/tekst-belastingbedrag/tekst-belastingbedrag.component';
import {
  TekstSpecDividenduitkeringenComponent
} from '../corporate/toelichtingen-tekst/tekst-spec-dividenduitkeringen/tekst-spec-dividenduitkeringen.component';
import {
  TekstSpecAandeelhoudersComponent
} from '../corporate/toelichtingen-tekst/tekst-spec-aandeelhouders/tekst-spec-aandeelhouders.component';
import {
  TekstSpecDeelnemingenComponent
} from '../corporate/toelichtingen-tekst/tekst-spec-deelnemingen/tekst-spec-deelnemingen.component';
import { BelastingplichtigeComponent } from '../corporate/belastingplichtige/belastingplichtige.component';
import { AdministratieKoppelenComponent } from '../corporate/administratie-koppelen/administratie-koppelen.component';
import { AlgemeenComponent } from '../corporate/algemeen/algemeen.component';
import { VragenFiscaleEenheidComponent } from '../corporate/vragen-fiscale-eenheid/vragen-fiscale-eenheid.component';
import {
  FiscaleEenheidSamenstellingComponent
} from '../corporate/fiscale-eenheid-samenstelling/fiscale-eenheid-samenstelling.component';
import { BalansActivaComponent } from '../corporate/balans-activa/balans-activa.component';
import { BalansPassivaComponent } from '../corporate/balans-passiva/balans-passiva.component';
import { ResultatenRekeningComponent } from '../corporate/resultaten-rekening/resultaten-rekening.component';
import { VermogensVergelijkingComponent } from '../corporate/vermogens-vergelijking/vermogens-vergelijking.component';
import { InvesteringenComponent } from '../corporate/investeringen/investeringen.component';
import {
  SpecCorrectiesBijzonderhedenComponent
} from '../corporate/spec-correcties-bijzonderheden/spec-correcties-bijzonderheden.component';
import { VrijgesteldeWinstComponent } from '../corporate/vrijgestelde-winst/vrijgestelde-winst.component';
import {
  BeperktAftrekbareKostenComponent
} from '../corporate/beperkt-aftrekbare-kosten/beperkt-aftrekbare-kosten.component';
import { NietAftrekbareBoetesComponent } from '../corporate/niet-aftrekbare-boetes/niet-aftrekbare-boetes.component';
import { NietAftrekbareRenteComponent } from '../corporate/niet-aftrekbare-rente/niet-aftrekbare-rente.component';
import { AftrekbareGiftenComponent } from '../corporate/culturele-giften/aftrekbare-giften.component';
import { OverigeGiftenComponent } from '../corporate/overige-giften/overige-giften.component';
import { VerliezenComponent } from '../corporate/verliezen/verliezen.component';
import { OverzichtComponent } from '../corporate/overzicht/overzicht.component';
import { BelastingBedragComponent } from '../corporate/belasting-bedrag/belasting-bedrag.component';
import { DividendsComponent } from '../corporate/dividends/dividends.component';
import { AandeelhoudersComponent } from '../corporate/aandeelhouders/aandeelhouders.component';
import { DeelnemingenComponent } from '../corporate/deelnemingen/deelnemingen.component';
import {
  WillekeurigAfschrijvenComponent
} from '../corporate/willekeurig-afschrijven/willekeurig-afschrijven.component';
import { SpecAgrarischComponent } from '../corporate/spec-agrarisch/spec-agrarisch.component';
import { InnovatieboxComponent } from '../corporate/innovatiebox/innovatiebox.component';
import { FunctioneleValutaComponent } from '../corporate/functionele-valuta/functionele-valuta.component';
import { FiscaleEenheidVoegingComponent } from '../corporate/fiscale-eenheid-voeging/fiscale-eenheid-voeging.component';
import {
  FiscaleEenheidOntvoegingComponent
} from '../corporate/fiscale-eenheid-ontvoeging/fiscale-eenheid-ontvoeging.component';
import {
  FiscaleEenheidOntbindingComponent
} from '../corporate/fiscale-eenheid-ontbinding/fiscale-eenheid-ontbinding.component';
import {
  FiscaleEenheidVerliezenComponent
} from '../corporate/fiscale-eenheid-verliezen/fiscale-eenheid-verliezen.component';
import { BronheffingComponent } from '../corporate/bronheffing/bronheffing.component';
import { SpecOpenActivaComponent } from '../corporate/spec-open-activa/spec-open-activa.component';
import { SpecOpenPassivaComponent } from '../corporate/spec-open-passiva/spec-open-passiva.component';
import { SpecSlotActivaComponent } from '../corporate/spec-slot-activa/spec-slot-activa.component';
import { SpecSlotPassivaComponent } from '../corporate/spec-slot-passiva/spec-slot-passiva.component';
import { EnkelvoudigeCijfersComponent } from '../corporate/enkelvoudige-cijfers/enkelvoudige-cijfers.component';
import { SpecOmzetbelastingComponent } from '../corporate/spec-omzetbelasting/spec-omzetbelasting.component';
import { SpecHirComponent } from '../corporate/spec-hir/spec-hir.component';
import { CommonModule } from '@angular/common';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-corporate-details',
  templateUrl: './feature-tax-corporate-details.component.html',
  styleUrls: ['./feature-tax-corporate-details.component.scss'],
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    TekstBelastingplichtigeComponent,
    TekstAdministratieKoppelenComponent,
    TekstVragenVoorafComponent,
    TekstSamenstellingFiscaleEenheidComponent,
    TekstVragenFiscaleEenheidComponent,
    TekstBalansActivaComponent,
    TekstBalansPassivaComponent,
    TekstResultatenrekeningComponent,
    TekstVermogensvergelijkingComponent,
    TekstVrijgesteldeWinstComponent,
    TekstBeperktAftrekbareKostenComponent,
    TekstNietAftrekbareRenteComponent,
    TekstInvesteringsaftrekComponent,
    TekstInvesteringenOverigComponent,
    TekstAftrekbareCultureleGiftenComponent,
    TekstAftrekbareGewoneGiftenComponent,
    TekstVerliesverrekeningComponent,
    TekstBelastbaarbedragComponent,
    TekstBelastingbedragComponent,
    TekstSpecDividenduitkeringenComponent,
    TekstSpecAandeelhoudersComponent,
    TekstSpecDeelnemingenComponent,
    BelastingplichtigeComponent,
    AdministratieKoppelenComponent,
    AlgemeenComponent,
    VragenFiscaleEenheidComponent,
    FiscaleEenheidSamenstellingComponent,
    BalansActivaComponent,
    BalansPassivaComponent,
    ResultatenRekeningComponent,
    VermogensVergelijkingComponent,
    InvesteringenComponent,
    SpecCorrectiesBijzonderhedenComponent,
    VrijgesteldeWinstComponent,
    BeperktAftrekbareKostenComponent,
    NietAftrekbareBoetesComponent,
    NietAftrekbareRenteComponent,
    AftrekbareGiftenComponent,
    OverigeGiftenComponent,
    VerliezenComponent,
    OverzichtComponent,
    BelastingBedragComponent,
    DividendsComponent,
    AandeelhoudersComponent,
    DeelnemingenComponent,
    WillekeurigAfschrijvenComponent,
    SpecAgrarischComponent,
    InnovatieboxComponent,
    FunctioneleValutaComponent,
    FiscaleEenheidVoegingComponent,
    FiscaleEenheidOntvoegingComponent,
    FiscaleEenheidOntbindingComponent,
    FiscaleEenheidVerliezenComponent,
    BronheffingComponent,
    SpecOpenActivaComponent,
    SpecOpenPassivaComponent,
    SpecSlotActivaComponent,
    SpecSlotPassivaComponent,
    EnkelvoudigeCijfersComponent,
    SpecOmzetbelastingComponent,
    SpecHirComponent
  ]
})
export class FeatureTaxCorporateDetailsComponent implements OnDestroy {

  @Input() public id!: string;
  private readonly destroyRef = inject(DestroyRef);
  private readonly dataService = inject(BokkzVpbDataService);
  private readonly vpbService = inject(BokkzVpbLogic);
  public readonly toastService = inject(ToastService);
  public corporateTaxEntity = {} as CorporateTaxEntity;
  public dialogInfoVisible = false;

  public detailsConfig = DetailsConfig.create({
    hideArrowButtons: true,
  });

  readonly corporateTaxEntity$: Observable<CorporateTaxEntity> =
    this.dataService.corporateTaxEntity$.pipe(
      filter((data): data is CorporateTaxEntity => !!data?.sstRelationId),
      tap(data => {
        this.corporateTaxEntity = data;
      }),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({bufferSize: 1, refCount: true})
    );

  readonly saveButtonConfig = ButtonConfiguration.create({
    onClick: () =>
      new Observable<void>((subscription) => {
        setTimeout(() => {
          this.saveForm(subscription);
        }, 200);
      }),
  });

  showButtonInfo(id: string): boolean {
    const toegestaneIds: string[] = [
      'Belastingplichtige',
      'Vragen vooraf',
      'Samenstelling fiscale eenheid',
      'Vragen fiscale eenheid',
      'Administratie inlezen',
      'Balans activa',
      'Balans passiva',
      'Resultatenrekening',
      'Vermogensvergelijking',
      'Vrijgestelde winst',
      'Beperkt aftrekbare kosten',
      'Niet aftrekbare rente',
      'Aftrekbare culturele giften',
      'Aftrekbare overige giften',
      'Investeringsaftrek',
      'Investeringen overig',
      'Verliesverrekening',
      'Belastbaar bedrag',
      'Belastingbedrag',
      'Specificatie dividenduitkeringen',
      'Specificatie aandeelhouders',
      'Specificatie deelnemingen'
    ];
    return toegestaneIds.includes(id);
  }

  showDialogInfo() {
    this.dialogInfoVisible = true;
  }


  ngOnDestroy(): void {
    // No-op: lifecycle cleanup is handled via takeUntilDestroyed.
  }

  saveForm(subscription: Subscriber<void>): void {
    setTimeout(() => {
      this.vpbService.postCorporateTaxEntity(this.corporateTaxEntity,false, false,true)
      subscription.next();
      subscription.complete();
    }, 500)
  }
}
